import { render, staticRenderFns } from "./UvozSipanjaGoriva.vue?vue&type=template&id=1839a2b2&scoped=true&"
import script from "./UvozSipanjaGoriva.vue?vue&type=script&lang=ts&"
export * from "./UvozSipanjaGoriva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839a2b2",
  null
  
)

export default component.exports